<template>
  <div>

    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <form method="#" action="#" @submit.prevent="validateBeforeSubmit()">
              <div class="col-md-8 col-md-offset-2">
                <div class="header-text">
                  <h2>Thank you for authenticating your product!</h2>
                  <h4>Please submit your registration.</h4>
                  <!--h5>Genuine Training Mask 3.0</h5-->
                  <hr>
                </div>
              </div>
              <div class="col-md-4 col-md-offset-2">
                <div class="card card-plain">
                    <div class="content">
                      <div class="form-group">
                        <input
                          type="text"
                          name="firstName"
                          v-model="model.firstName"
                          v-validate="modelValidations.firstName"
                          placeholder="First Name"
                          class="form-control">
                        <small class="text-danger" v-show="firstName.invalid">
                          {{ getError('firstName') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          name="lastName"
                          v-model="model.lastName"
                          v-validate="modelValidations.lastName"
                          placeholder="Last Name"
                          class="form-control">
                        <small class="text-danger" v-show="lastName.invalid">
                          {{ getError('lastName') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <input
                          type="email"
                          name="email"
                          v-model="model.email"
                          v-validate="modelValidations.email"
                          placeholder="Email"
                          class="form-control">
                        <small class="text-danger" v-show="email.invalid">
                          {{ getError('email') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          name="address1"
                          v-model="model.address1"
                          v-validate="modelValidations.address1"
                          placeholder="Addres Line 1"
                          class="form-control">
                        <small class="text-danger" v-show="address1.invalid">
                          {{ getError('address1') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          name="address2"
                          v-model="model.address2"
                          v-validate="modelValidations.address2"
                          placeholder="Address Line 2"
                          class="form-control">
                        <small class="text-danger" v-show="address2.invalid">
                          {{ getError('address2') }}
                        </small>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="col-md-4">
                  <div class="card card-plain">
                    <div class="content">
                      <div class="form-group">
                        <input
                          type="text"
                          name="city"
                          v-model="model.city"
                          v-validate="modelValidations.city"
                          placeholder="City"
                          class="form-control">
                        <small class="text-danger" v-show="city.invalid">
                          {{ getError('city') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          name="state"
                          v-model="model.state"
                          v-validate="modelValidations.state"
                          placeholder="State"
                          class="form-control">
                        <small class="text-danger" v-show="state.invalid">
                          {{ getError('state') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          name="zip"
                          v-model="model.zip"
                          v-validate="modelValidations.zip"
                          placeholder="Postal Code"
                          class="form-control">
                        <small class="text-danger" v-show="zip.invalid">
                          {{ getError('zip') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          name="country"
                          v-model="model.country"
                          v-validate="modelValidations.country"
                          placeholder="Country"
                          class="form-control">
                        <small class="text-danger" v-show="country.invalid">
                          {{ getError('country') }}
                        </small>
                      </div>
                    </div>
                    <div class="footer text-center">
                      <button type="button" v-if="!loading" @click.prevent="validateBeforeSubmit()" class="btn btn-fill btn-danger btn-wd">Submit!</button>
                      <button type="button" v-if="loading" class="btn btn-wd btn-danger" disabled="disabled">
                        <span class="btn-label">
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </span>
                        Sign Up!
                      </button>
                    </div>
                  </div>
              </div>
              </form>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright text-center">
              &copy; Copyright 2018 Authentic.net
            </div>
          </div>
        </footer>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <li>
          <router-link to="/login">
            Looking to login?
          </router-link>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
// import { stripeKey, stripeOptions } from './stripeConfig.json'
import { Card, createToken } from 'vue-stripe-elements-plus'
import { uuid } from 'vue-uuid'
import swal from 'sweetalert2'
import {mapFields} from 'vee-validate'
import qs from 'qs'
import db from '@/components/firebase/init'
import firebase from 'firebase'
import 'firebase/functions'
import { toolboxMixin } from '@/components/mixins/toolboxMixin'

export default {
  computed: {
    ...mapFields(['firstName',
      'lastName',
      'email',
      'address1',
      'address2',
      'city',
      'state',
      'zip',
      'country'])
  },
  mixins: [toolboxMixin],
  data () {
    return {
      myvariable: 4,
      modelValidations: {
        firstName: {
          required: true
        },
        lastName: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        city: {
          required: true
        },
        state: {
          required: true
        },
        zip: {
          required: true
        },
        country: {
          required: true
        }
      },
      axios_config: {
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'text'
      },
      stripe_plan_fetched: false,
      loading: false,
      step: 1,
      complete: false,
      stripe_customer_id: '',
      model: {
        firstName: '',
        lastName: '',
        email: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: ''
      },
      code: false,
      submitData: {}
    }
  },

  components: { Card },

  methods: {
    async init () {
      this.submitData.code = this.code
      // this.submitData.clientIpData = await this.getClientIpData()
      this.submitData.clientIp = await this.getClientIp()
    },
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
    submit () {
      this.submitData.contactDetails = this.model
      console.log(this.submitData)
      let registerAuthCode = firebase.functions().httpsCallable('registerAuthCode')
      registerAuthCode(this.submitData)
      .then(result => {
        if (!result.data.success) {
          this.$router.replace('/authenticate?code=' + this.code)
        }
        console.log('result', result)
        var product = result.data.product
        console.log('product', product)
        swal.fire({
          title: `Thank you!`,
          text: 'Congratulations! You have successfully registered your product.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        })
        .then(result => {
          if (product.data.redirectUrl) location.replace(product.data.redirectUrl)
          else location.replace('https://www.trainingmask.com')
        })
        .catch(err => {
          console.log(err)
          if (product.data.redirectUrl) location.replace(product.data.redirectUrl)
          else location.replace('https://www.trainingmask.com')
        })
        this.loading = false
      })
    },
    signup () {
      console.log('signing up')
      let signup = firebase.functions().httpsCallable('signup')
      signup(this.model)
      .then(result => {
        console.log(result)
      })
      .catch(err => {
        console.error(err.message)
      })
    },
    beforeDestroy () {
      this.closeMenu()
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validateBeforeSubmit () {
      this.loading = true
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.submit()
          // this.signup()
        } else {
          this.loading = false
        }
      })
    }
  },

  mounted: function () {
    this.$nextTick(function () {
      if (this.$route.params.code) this.code = this.$route.params.code
      else if (this.$route.query.code) this.code = this.$route.query.code
      if (!this.code) this.$router.replace('/authenticate')
      this.init()
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/RegisterCode.vue